import { useQuery } from 'react-query';
import { Http } from '../../services/Http';
import { MonthlyTimesheetToExport } from '../../types';
import { QUERY_KEYS } from '../constants';

async function fetchOpenTimesheetsToExport(): Promise<MonthlyTimesheetToExport[]> {
  const { data } = await Http.axios.get<MonthlyTimesheetToExport[]>('/monthly-timesheet/open');
  return data;
}

/**
 * Every submitter's not-yet-closed timesheets, for the accountant's one-click export.
 *
 * The endpoint takes no arguments - it always answers "what is still outstanding" - so `requestId`
 * exists purely to key the cache: `0` leaves the query idle, and each click passes a higher number,
 * which starts a genuinely fresh read instead of handing back the snapshot from an earlier click.
 * That matters because the whole point of the export is the state of things right now, and because
 * the response covers the entire organisation rather than one page of it.
 */
export const useOpenTimesheetsToExport = (requestId: number) => {
  return useQuery(
    [QUERY_KEYS.OPEN_MONTHLY_TIMESHEETS_TO_EXPORT, requestId],
    fetchOpenTimesheetsToExport,
    {
      enabled: requestId > 0,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      refetchIntervalInBackground: false,
    }
  );
};
